import { render } from "./ListDeselect.vue?vue&type=template&id=ba1b0700&scoped=true"
const script = {}

import "./ListDeselect.vue?vue&type=style&index=0&id=ba1b0700&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba1b0700"]])

export default __exports__